import React, { memo, useEffect, useRef, useState } from 'react';
import SmallCheckIcon from '../../kit/icons/SmallCheckIcon';
import { Box, Typography, useMediaQuery } from '@mui/material';

const PointsList = memo(({ list, iconSx, textProps, pointIcon }) => {
  const isAboveMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const isBelowLg = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const [isMediaQueryReady, setIsMediaQueryReady] = useState(false);
  useEffect(() => {
    if (!isMediaQueryReady && (isAboveMd || isBelowLg)) {
      setIsMediaQueryReady(true);
    }
  }, [isAboveMd, isBelowLg]);

  const listRefs = useRef([]);
  useEffect(() => {
    setTimeout(() => {
      if (isMediaQueryReady) {
        listRefs.current.forEach((item) => {
          const textHeight = item && item.querySelector('.text').offsetHeight;
          const iconHeight = item && item.querySelector('.icon').offsetHeight;
          if (item) {
            if (textHeight > iconHeight) {
              item.style.alignItems = 'flex-start';
            } else {
              item.style.alignItems = 'center';
            }
          }
        });
      }
    }, 50);
  }, [list, isMediaQueryReady]);

  return (
    <Box>
      {list.map((point, index) => (
        <Box
          ref={(el) => (listRefs.current[index] = el)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            zIndex: 1,
            ':not(:first-of-type)': { mt: 2 },
          }}
          key={point}
        >
          <Box
            className="icon"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 20,
            }}
          >
            {pointIcon || <SmallCheckIcon sx={iconSx} />}
          </Box>
          <Typography
            className="text"
            variant="desktopP3"
            fontSize={{ xs: 12, md: 14 }}
            color={'kit.text.main'}
            {...textProps}
          >
            {point}
          </Typography>
        </Box>
      ))}
    </Box>
  );
});

export default PointsList;
